import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import {
  DetailsSkeleton,
  TextSkeleton,
} from '../../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { useGlobalProductContext } from '../../../../../contexts';

export const ListLoadingItemTablet: React.FC = () => {
  const { product } = useGlobalProductContext();

  const topInfos = [
    {
      label: 'Tipo Oferta',
      value: (
        <HStack space={Spacing['inline.quarck']} alignItems="center">
          <DetailsSkeleton />
          <TextSkeleton w="60%" />
        </HStack>
      ),
      maxW: '24%',
    },
    { label: 'Nome', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: 'Cód. Isin', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: 'Alteração', value: <TextSkeleton w="60%" />, maxW: '24%' },
  ];

  const bottomInfos = [
    { label: 'Negociação', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: 'Liquidação', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: 'Perfil', value: <TextSkeleton w="60%" />, maxW: '24%' },
    { label: 'Limitador', value: <TextSkeleton w="60%" />, maxW: '24%' },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="start">
          {topInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} w={maxW} space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {bottomInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} w={maxW} space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
      </VStack>
    </TableContent>
  );
};
